module.exports = __webpack_public_path__ + "static/media/Excel.ed278049.svg";